import { Box, Tag } from '@factorialco/deprecated-design-system'

import { useTrainingMemberships } from 'modules/trainings/hooks/TrainingMemberships/useTrainingMemberships'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

interface Props {
  trainingId: number
  employeeId: number
}

export const AttendanceTag = ({ trainingId, employeeId }: Props) => {
  const { getTrainingAttendanceColor, getTrainingAttendanceTranslation } = useTrainingsDatatable()

  const { trainingMemberships } = useTrainingMemberships({
    trainingId: Number(trainingId),
    employeeId: Number(employeeId),
  })

  const trainingMembership = trainingMemberships.find(
    (membership) => membership.employeeId === Number(employeeId)
  )

  if (!trainingMembership) return null

  return (
    <Box width="fit-content">
      <Tag
        leftItem="circle"
        showCircle
        type={getTrainingAttendanceColor(trainingMembership.status)}
      >
        {getTrainingAttendanceTranslation(trainingMembership.status)}
      </Tag>
    </Box>
  )
}
